import type registry from '@content/assets.json';
import config from '@config/static-assets.json';
import { isHostedAsset as isHosted } from '@lib/asset-urls';
import { assetImageQuery } from '@lib/asset-image-options';
import type { AssetImageOptions } from '@lib/asset-image-options';
import type { SafeUrl } from '@types';

export type AssetKey = keyof typeof registry;

/** Stable keys keep page references independent of the storage origin. */
export const assetUrl = (
  key: AssetKey,
  options?: AssetImageOptions,
): SafeUrl => {
  const query = options && assetImageQuery(options);
  return `/assets/${encodeURIComponent(key)}${query ? `?${query}` : ''}` as SafeUrl;
};

export const resolveAssetReference = (value: string): string =>
  value.startsWith('asset:') ? assetUrl(value.slice(6) as AssetKey) : value;

export const isHostedAsset = (value: string) =>
  isHosted(value, config.publicBaseUrl, config.prefix);

export const isAssetUrl = (value: string) => value.startsWith('/assets/');
